import { inject, Injectable, Type } from '@angular/core';

import { createAction, props } from '@ngrx/store';

import type { CurrentUser } from '@recruitee/account-types';
import { ADMIN, COMPANY_ID } from '@recruitee/common';

export type ElementMapping = Array<[string, () => Promise<Type<any>>]>;

export const integrationsAccountFactory = (): Account => {
  const admin: CurrentUser = inject(ADMIN);
  const companyId = inject(COMPANY_ID);
  const company = admin.companies.find(({ id }) => id === companyId)!;

  return {
    admin: {
      id: admin.id,
      email: admin.email,
      firstName: admin.firstName,
      lastName: admin.lastName,
      photoThumbUrl: admin.photoThumbUrl,
      hasAvatar: admin.hasAvatar,
      initials: admin.initials,
    },
    company: {
      id: company.id,
      name: company.name,
      usingLegacyCareers: company.usingLegacyCareers,
      legacyCareersDisabled: company.legacyCareersDisabled,
    },
    role: { id: admin.roleId },
  };
};

@Injectable({
  providedIn: 'root',
  useFactory: integrationsAccountFactory,
})
export abstract class Account {
  public admin: {
    id: number;
    email: string;
    firstName: string;
    lastName: string;
    photoThumbUrl: string;
    hasAvatar: boolean;
    initials: string;
  };
  public company: {
    id: number;
    name: string;
    usingLegacyCareers: boolean;
    legacyCareersDisabled: boolean;
  };
  public role: { id: number };
}

export const IntegrationsActions = {
  updateJobBoards: createAction(
    '[Integrations] UpdateJobBoards',
    props<{ payload: { offerId: number } }>(),
  ),
};
